// This file is automatically generated by the sync-app-options script.
// Do not edit this file directly.
export const REVIEWABLE_DOCUMENT_FLOWS = ['NIF_INTAKE'];
export const REVIEWABLE_DOCUMENT_CATEGORY_PREFIX = 'translation:reviewable_document_category';
// i18n.t('translation:reviewable_document_category.nif_parent_proof_of_identity', 'NIF Parent Proof of Identity')
// i18n.t('translation:reviewable_document_category.nif_proof_of_identity', 'NIF Proof of Identity')
// i18n.t('translation:reviewable_document_category.nif_portuguese_birth_certificate', 'NIF Portuguese Birth Certificate')
// i18n.t('translation:reviewable_document_category.nif_additional_document', 'NIF Additional Document')
// i18n.t('translation:reviewable_document_category.nif_proof_of_address', 'NIF Proof of Address')
// i18n.t('translation:reviewable_document_category.nif_minor_birth_certificate', 'NIF Minor Birth Certificate')
// i18n.t('translation:reviewable_document_category.nif_signed_power_of_attorney', 'NIF Signed Power of Attorney')
export const REVIEWABLE_DOCUMENT_CATEGORIES = {
    nif_parent_proof_of_identity: {
        id: '78ad4904-3f1b-46bf-b63d-3418897253ae',
        name: 'NIF Parent Proof of Identity',
        key: 'nif_parent_proof_of_identity',
        flows: ['NIF_INTAKE'],
    },
    nif_proof_of_identity: {
        id: '799839d3-f45b-4ab3-8a85-dcf05fa346b3',
        name: 'NIF Proof of Identity',
        key: 'nif_proof_of_identity',
        flows: ['NIF_INTAKE'],
    },
    nif_portuguese_birth_certificate: {
        id: 'cb86742b-d961-4aef-bc48-f4266ac25b8f',
        name: 'NIF Portuguese Birth Certificate',
        key: 'nif_portuguese_birth_certificate',
        flows: ['NIF_INTAKE'],
    },
    nif_additional_document: {
        id: '4ea1e578-a318-42f3-80f0-f18953de62e8',
        name: 'NIF Additional Document',
        key: 'nif_additional_document',
        flows: ['NIF_INTAKE'],
    },
    nif_proof_of_address: {
        id: '1093ba34-5740-45fb-8edd-57a69da0bf7e',
        name: 'NIF Proof of Address',
        key: 'nif_proof_of_address',
        flows: ['NIF_INTAKE'],
    },
    nif_minor_birth_certificate: {
        id: '0c5d7034-a87f-4049-a178-33a73277a2d1',
        name: 'NIF Minor Birth Certificate',
        key: 'nif_minor_birth_certificate',
        flows: ['NIF_INTAKE'],
    },
    nif_signed_power_of_attorney: {
        id: '33b05084-309b-4fd5-af28-a4e83582d3df',
        name: 'NIF Signed Power of Attorney',
        key: 'nif_signed_power_of_attorney',
        flows: ['NIF_INTAKE'],
    },
};
//# sourceMappingURL=reviewable-document-category.js.map